import fetchRootCategories from"./fetchRootCategories";import fetchCategory from"./fetchCategory";/**
 * Retrieves a category from the server.
 * @param {string} categoryId The category ID.
 * @return {Function} The dispatched action.
 */var getCategory=function getCategory(categoryId){return function(dispatch){if(!categoryId){dispatch(fetchRootCategories());return;}dispatch(fetchCategory(categoryId));};};export default getCategory;